
  <h3 class="font-medium text-lg mb-4 text-purple-700">{{ 'Fuentes de datos para RAG' | translate }}</h3>
  <div>
    <p class="text-sm text-gray-600 mb-6">
      {{ 'Las fuentes de datos configuradas enriquecen las respuestas del sistema mediante RAG.' | translate }}
    </p>
  </div>
  <div class="grid grid-cols-4 gap-4 mb-6">
      <app-tarjeta-resumen-datos [titulo]="'Agentes SQL'"
                                 [subtitulo]="numeroAgentesSql() === 1 ? numeroAgentesSql() + ' agente SQL' : numeroAgentesSql() + ' agentes SQL'"
                                 [icono]="'circle-stack.svg'"
                                 [color]="'bg-blue-100'"
                                 [cargando]="cargando()">
      </app-tarjeta-resumen-datos>
      <app-tarjeta-resumen-datos [titulo]="'Fuentes'"
                                 [subtitulo]="numeroFuenteDatos() > 1 ? numeroFuenteDatos() + ' fuentes de datos' : numeroFuenteDatos() + ' fuente de datos'"
                                 [icono]="'rectangle-stack.svg'"
                                 [color]="'bg-amber-100'"
                                 [cargando]="cargando()">
      </app-tarjeta-resumen-datos>
      <app-tarjeta-resumen-datos [titulo]="'Colecciones'"
                                 [subtitulo]="numeroColecciones() > 1 ? numeroColecciones() + ' colecciones' : numeroColecciones() + ' colección'"
                                 [icono]="'document-text.svg'"
                                 [color]="'bg-purple-100'"
                                 [cargando]="cargando()">
      </app-tarjeta-resumen-datos>
      <app-tarjeta-resumen-datos [titulo]="'Agentes'"
                                 [subtitulo]="numeroAgentes() > 1 ? numeroAgentes() + ' agentes' : numeroAgentes() + ' agente'"
                                 [icono]="'document-magnifying-glass.svg'"
                                 [color]="'bg-blue-100'"
                                 [cargando]="cargando()">
      </app-tarjeta-resumen-datos>
    </div>
  <div class="bg-indigo-50 p-4 rounded-xl border border-indigo-100 mt-5">
    <h4 class="text-xs font-medium mb-2 text-indigo-700 flex items-center">
      <img src="../../../../../assets/img/iconos/shield-exclamation.svg" alt="" height="20" width="20" class="mr-1">
      {{ 'Información sobre RAG' | translate }}
    </h4>
    <p class="text-xs text-indigo-600">
      {{ 'El sistema RAG (Retrieval Augmented Generation) enriquece las respuestas del modelo con datos extraídos de tus fuentes personalizadas, mejorando la precisión y relevancia para casos de uso específicos.' | translate }}
    </p>
  </div>
